// @flow
export const NotFoundRoute = "/fehler";
